import React from 'react';
import { Row } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import styled from 'styled-components';

import { POCValue, POCWrapper } from 'screens/student-details/styled-comps';
import { CopyButton } from 'comps';
import { getFormatedDate } from 'utils';
import { LAPSE_LOG_ADMIN_URL } from 'constants/api';

const CourseInfoHeading = styled(Text)`
  min-width: ${({ minWidth }) => (minWidth ? minWidth : '152px')};
  margin-right: 16px;
  color: rgba(43, 43, 43, 0.75);
  line-height: 20px;
  cursor: ${({ cursor }) => (cursor ? cursor : 'default')};
  width: ${({ width }) => (width ? width : 'auto')};
`;

const CustomRow = styled(Row)`
  flex-wrap: nowrap;
  padding: 10px 0px;
  align-items: center;
`;

const getDate = date => {
  return date ? getFormatedDate(date) : '-';
};

function CoursesInfo(props) {
  const {
    class_start_date: startDate,
    classes_balance: classBalance,
    classes_purchased: classPurchased,
    enrollment_type: enrollmentType,
    id,
    onViewCourseLog,
    source,
    state,
    student_id: studentId,
    validity_till_date: endDate,
    classes_per_week: classesPerWeek,
    class_ratio: classRatio,
    is_new_subscription_policy: isNewSubscriptionPolicy,
  } = props || {};

  return (
    <POCWrapper>
      <CustomRow>
        <CourseInfoHeading variant="eyebrow2">START DATE</CourseInfoHeading>
        <POCValue variant="body1Medium">{getDate(startDate) || '-'}</POCValue>
      </CustomRow>
      <CustomRow>
        <CourseInfoHeading variant="eyebrow2">END DATE</CourseInfoHeading>
        <POCValue variant="body1Medium">{getDate(endDate) || '-'}</POCValue>
      </CustomRow>
      <CustomRow>
        <CourseInfoHeading variant="eyebrow2">CLASS LOG</CourseInfoHeading>
        <POCValue
          textDecoration="underline"
          variant="body1Medium"
          onClick={() => onViewCourseLog(id, studentId)}
        >
          View
        </POCValue>
      </CustomRow>
      <CustomRow>
        <CourseInfoHeading variant="eyebrow2">LAPSE LOG</CourseInfoHeading>
        <POCValue
          textDecoration="underline"
          variant="body1Medium"
          onClick={() => id && window.open(`${LAPSE_LOG_ADMIN_URL}${id}`, '_blank')}
        >
          View
        </POCValue>
      </CustomRow>
      <CustomRow>
        <CourseInfoHeading variant="eyebrow2">STUDENT COURSE ID</CourseInfoHeading>
      </CustomRow>
      <CustomRow marginTop="4px">
        <CopyButton copyMessage="Copy Student Course Id" text={id || '-'} />
      </CustomRow>
      <CustomRow>
        <CourseInfoHeading variant="eyebrow2">STATUS</CourseInfoHeading>
        <POCValue variant="body1Medium">{state || '-'}</POCValue>
      </CustomRow>
      <CustomRow>
        <CourseInfoHeading variant="eyebrow2">ENROLLMENT TYPE</CourseInfoHeading>
        <POCValue variant="body1Medium">{enrollmentType || '-'}</POCValue>
      </CustomRow>
      <CustomRow>
        <CourseInfoHeading variant="eyebrow2">CLASSES PURCHASED</CourseInfoHeading>
        <POCValue variant="body1Medium">{classPurchased || '-'}</POCValue>
      </CustomRow>
      <CustomRow>
        <CourseInfoHeading variant="eyebrow2">CLASSES REMAINING</CourseInfoHeading>
        <POCValue variant="body1Medium">{classBalance || '-'}</POCValue>
      </CustomRow>
      <CustomRow>
        <CourseInfoHeading variant="eyebrow2">CLASSES PER WEEK</CourseInfoHeading>
        <POCValue variant="body1Medium">{classesPerWeek || '-'}</POCValue>
      </CustomRow>
      <CustomRow>
        <CourseInfoHeading variant="eyebrow2">CLASS RATIO</CourseInfoHeading>
        <POCValue variant="body1Medium">{classRatio ? `1:${classRatio}` : '-'}</POCValue>
      </CustomRow>
      <CustomRow>
        <CourseInfoHeading variant="eyebrow2">SOURCE</CourseInfoHeading>
        <POCValue variant="body1Medium">{source || '-'}</POCValue>
      </CustomRow>
      <CustomRow>
        <CourseInfoHeading variant="eyebrow2">NEW SUBSCRIPTION</CourseInfoHeading>
        <POCValue variant="body1Medium">
          {isNewSubscriptionPolicy ? 'Yes' : 'No'}
        </POCValue>
      </CustomRow>
    </POCWrapper>
  );
}

export default CoursesInfo;
